import React from "react";
// ----page import------------------------------
import FillFormStep from "./pages/LoanProcess/FillFormStep";
import FillFormStep2 from "./pages/LoanProcess/FillFormStep2";
import FillFormStep3 from "./pages/LoanProcess/FillFormStep3";
import FillFormStep4 from "./pages/LoanProcess/FillFormStep4";
import FillFormSuccess from "./pages/LoanProcess/FillFormSuccess";
import FormIncome from "./pages/LoanProcess/FormIncome";
import FormProfile from "./pages/LoanProcess/FormProfile";
import Otp from "./pages/LoanProcess/Otp";
import StartLoanInfo from "./pages/LoanProcess/StartLoanInfo";
import Firstpage from "./pages/LoginPage/Firstpage";
import NotificationsPage from "./pages/NotificationsPage/NotificationsPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import FormRegister from "./pages/RegisterMain/FormRegister";
import FormSuccess from "./pages/RegisterMain/FormSuccess";
import SelectLoan from "./pages/SelectLoan/SelectLoan";
import RegisterNation from "./pages/SelectNation/RegisterNation";
// ----page import------------------------------
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "../src/assets/css/theme.css";
import "../src/assets/css/style.css";
import "./App.css";
import AuthRequiredRoute from "./components/auth/AuthRequiredRoute/AuthRequiredRoute";
import "./i18n.js";
import AcceptAgreementDocumentPage from "./pages/AcceptAgreementDocument/AcceptAgreementDocumentPage";
import CheckNewLoanPrincipal from "./pages/CheckNewLoanPrincipal/CheckNewLoanPrincipal";
import ContactUs from "./pages/ContactUs/ContactUs";
import EditMyLoanPage from "./pages/EditMyLoan/EditMyLoanPage";
import EditMyProfilePage from "./pages/EditMyProfile/EditMyProfilePage";
import LoanDetailPage from "./pages/LoanDetail/LoanDetailPage";
import NanoLoanDetailPage from "./pages/LoanDetail/NanoLoanDetailPage";
import PersonalLoanDetailPage from "./pages/LoanDetail/PersonalLoanDetailPage";
import PicoLoanDetailPage from "./pages/LoanDetail/PicoLoanDetailPage";
import SeeLoanDetailPage from "./pages/LoanDetail/SeeLoanDetailPage";
import { PaymentPage } from "./pages/MyLoan";
import MyLoanPage from "./pages/MyLoan/MyLoanPage";
import MyLoanDetailPage from "./pages/MyLoanDetail/MyLoanDetailPage";
import { MyLoanInvoice } from "./pages/MyLoanInvoice/MyLoanInvoice";
import DownloadLoanContractPage from "./pages/MyLoanReceipt/DownloadLoanContractPage";
import InstallmentReceiptDetailPage from "./pages/MyLoanReceipt/InstallmentReceiptDetailPage";
import MyLoanReceipt from "./pages/MyLoanReceipt/MyLoanReceipt";
import MyLoanStatusPage from "./pages/MyLoanStatus/MyLoanStatusPage";

function App() {
  return (
    <div className="main-wrapper">
      <Router>
        <Routes>
          <Route path="/" element={<Firstpage />} />
          <Route path="/register" element={<RegisterNation />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/register/form" element={<FormRegister />} />
          <Route path="/register/success" element={<FormSuccess />} />
          {/* ----------------------เริ่มต้นการสมัครสินเชื่อ 1---------------------- */}
          <Route
            path="/select-loan/income"
            element={
              <AuthRequiredRoute>
                <FormIncome />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/select-loan"
            element={
              <AuthRequiredRoute>
                <SelectLoan />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/select-loan/:productId"
            element={
              <AuthRequiredRoute>
                <LoanDetailPage />
              </AuthRequiredRoute>
            }
          />

          <Route path="/see-loan/:productId" element={<SeeLoanDetailPage />} />
          <Route
            path="/loan/personal-loan"
            element={<PersonalLoanDetailPage />}
          />
          <Route
            path="/loan/pico-finance-loan"
            element={<PicoLoanDetailPage />}
          />
          <Route
            path="/loan/nano-finance-loan"
            element={<NanoLoanDetailPage />}
          />
          {/* <Route path="/select-loan/pico" element={<PicoDetail />} /> */}
          {/* <Route path="/select-loan/personal" element={<PersonalDetail />} /> */}
          {/* ----------------------เริ่มต้นการสมัครสินเชื่อ 2---------------------- */}
          <Route path="/loan-process" element={<StartLoanInfo />} />
          <Route path="/loan-process/form-step1" element={<FillFormStep />} />
          <Route path="/loan-process/form-step2" element={<FillFormStep2 />} />
          <Route path="/loan-process/form-step3" element={<FillFormStep3 />} />
          <Route path="/loan-process/form-step4" element={<FillFormStep4 />} />
          <Route
            path="/loan-process/form-success"
            element={<FillFormSuccess />}
          />
          <Route
            path="/loan-process/form-profile"
            element={
              <AuthRequiredRoute>
                <FormProfile />
              </AuthRequiredRoute>
            }
          />
          <Route path="/loan-process/otp" element={<Otp />} />
          {/* ----------------------page profile---------------------- */}
          <Route
            path="/profile"
            element={
              <AuthRequiredRoute>
                <ProfilePage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/profile/edit"
            element={
              <AuthRequiredRoute>
                <EditMyProfilePage />
              </AuthRequiredRoute>
            }
          />
          {/* ---------------------- รายการสินเชื่อของฉัน -------------------- */}
          <Route
            path="/my-loans"
            element={
              <AuthRequiredRoute>
                <MyLoanPage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loans/:loanId"
            element={
              <AuthRequiredRoute>
                <MyLoanDetailPage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loans/:loanId/edit"
            element={
              <AuthRequiredRoute>
                <EditMyLoanPage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loans/:loanId/receipt"
            element={
              <AuthRequiredRoute>
                <MyLoanReceipt />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loans/:loanId/invoice"
            element={
              <AuthRequiredRoute>
                <MyLoanInvoice />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loans/:loanId/status"
            element={
              <AuthRequiredRoute>
                <MyLoanStatusPage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loans/:loanId/check-new-loan-principal"
            element={
              <AuthRequiredRoute>
                <CheckNewLoanPrincipal />
              </AuthRequiredRoute>
            }
          />

          <Route
            path="/my-loans/:loanId/accept-agreement-document"
            element={
              <AuthRequiredRoute>
                <AcceptAgreementDocumentPage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loans/:loanId/payment"
            element={
              <AuthRequiredRoute>
                <PaymentPage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loan-receipt/:loanId/:installmentId/detail"
            element={
              <AuthRequiredRoute>
                <InstallmentReceiptDetailPage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/my-loan-contract/:loanId"
            element={
              <AuthRequiredRoute>
                <DownloadLoanContractPage />
              </AuthRequiredRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <AuthRequiredRoute>
                <NotificationsPage />
              </AuthRequiredRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
